<template>
  <div class="the-password-reset">
    <div class="title-wrap">
      <div class="title-item">{{ $t('public.resetPassword') }}</div>
    </div>

    <a-form :form="form" @submit="submit" class="sign-in-form">
      <a-form-item :colon="false" :label="$t('public.email')">
        <a-input
          :placeholder="$t('public.email')"
          v-decorator="[
            'email',
            {
              rules: [
                {
                  required: true,
                  message: $t('public.pleaseFill', {
                    content: $t('public.email')
                  })
                }
              ]
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item :colon="false" :label="`${$t('public.verificationCode')}`">
        <a-input-search
          :placeholder="$t('public.verificationCode')"
          v-decorator="[
            'verificationCode',
            {
              rules: [
                {
                  required: true,
                  message: $t('public.pleaseFill', {
                    content: $t('public.verificationCode')
                  })
                }
              ]
            }
          ]"
          @search="sendCode"
        >
          <a-button
            :disabled="sendDisabled || sendLoading"
            slot="enterButton"
            type="primary"
          >
            <div style="width:30px; text-align: center;">
              {{ sendLoading ? sendTime + ' S' : $t('handle.send') }}
            </div>
          </a-button>
        </a-input-search>
      </a-form-item>
      <a-form-item :colon="false" :label="`${$t('user.password')}`">
        <a-input
          :placeholder="$t('user.password')"
          type="password"
          v-decorator="[
            'password',
            {
              rules: [
                {
                  required: true,
                  message: $t('public.pleaseFill', {
                    content: $t('user.password')
                  })
                },
                {
                  validator: validateConfirmPassword
                }
              ]
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item :colon="false" :label="`${$t('user.confirmPassword')}`">
        <a-input
          :placeholder="$t('user.confirmPassword')"
          type="password"
          v-decorator="[
            'confirmPassword',
            {
              rules: [
                {
                  required: true,
                  message: $t('user.confirmPasswordTip')
                },
                {
                  validator: comparePassword
                }
              ]
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-button block type="primary" html-type="submit">
          {{ $t('handle.confirm') }}
        </a-button>

        <a-button block type="default" @click="back">
          {{ $t('handle.back') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
const maxTime = 60

export default {
  data() {
    return {
      form: this.$form.createForm(this),
      sendDisabled: false,
      sendLoading: false,

      sendTime: 60
    }
  },

  watch: {
    // 更新form检测信息的翻译
    '$i18n.locale'() {
      this.$nextTick(() => {
        const fieldsError = this.form.getFieldsError()
        let fieldsErrorName = []

        for (const key in fieldsError) {
          if (fieldsError[key]) {
            fieldsErrorName.push(key)
          }
        }

        if (fieldsErrorName.length > 0) {
          this.form.validateFields(fieldsErrorName, { force: true }, () => {})
        }
      })
    }
  },

  methods: {
    sendCode() {
      this.form.validateFields(['email'], { force: true }, (err, val) => {
        if (!err) {
          this.sendDisabled = true
          this.$http(this.$api.SENDVERIFICATIONCODE, {
            account: val.email
          })
            .then(() => {
              this.sendDisabled = false
              this.$message.success(this.$t('user.sendSuccess'))
              this.setTime()
            })
            .catch(() => {
              this.sendDisabled = false
            })
        }
      })
    },

    setTime() {
      this.sendTime = maxTime

      this.timeout()
    },

    timeout() {
      if (this.sendTime > 0) {
        this.sendLoading = true
        setTimeout(() => {
          this.sendTime--
          this.timeout()
        }, 1000)
      } else {
        this.sendLoading = false
      }
    },

    // 修改密码
    validateConfirmPassword(rule, value, callback) {
      const confirmPassword = this.form.getFieldValue('confirmPassword')
      if (value && confirmPassword) {
        this.form.validateFields(['confirmPassword'], { force: true }, () => {})
      }
      callback()
    },

    comparePassword(rule, value, callback) {
      const password = this.form.getFieldValue('password')
      if (value && password && value !== password) {
        callback(this.$t('user.passwordsInconsistent'))
      } else {
        callback()
      }
    },

    submit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.resetPassword({
            account: values.email,
            code: values.verificationCode,
            password: values.password
          })
        }
      })
    },

    resetPassword(loginData) {
      this.$http(this.$api.RESETPASSWORD, {
        account: loginData.account,
        code: loginData.code,
        password: loginData.password
      }).then(() => {
        this.$message.success(this.$t('user.changePasswordSuccess'))
        this.back()
      })
    },

    back() {
      this.$store.commit('SET_HANDLETYPE', 'the-sign-in')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../style/variable.less';

.the-password-reset {
  width: 400px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  overflow: hidden;
  background-color: #fff;
  margin-top: -30px;
  .title-wrap {
    background-color: @themeColor;
    padding: 30px 25px 20px;
    color: #fff;
    text-align: center;
    .title-item {
      font-size: 24px;
      line-height: 1;
      // margin-top: 10px;
    }
  }
  .sign-in-form {
    margin-top: 20px;
    padding: 0 25px 10px;
  }
}
</style>

<style lang="less">
.sign-in-form {
  .ant-form-item-label {
    line-height: 1;
  }
}
</style>
